export class CustomerFilter {
  customerNumber?: string;
  type?:string;
  createdFrom?: string;
  createdTo?: string;
  initiator?: string;
  gender?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email?: string;
  status?: string;
  birthDate?: string;
  phoneNumber?: string;
  passportSerialNumber?: string;
  foreignPassport?: string;
  otherDocument?: string;
  idCard?: string;
  socialSecurityNumber?: string;
  street?: string;
  taxpayerId?: string;
  commercialName?: string;
  commercialAddress?: string;
  name?: string;
  resident?:boolean;
  documentType?: string;
}
